import errorIcon from "../assets/images/common/error_icon.png";
import {useLocation, useNavigate} from "react-router-dom";
import {getArtistFromPath} from "src/utils/artist.utils";
import {useTranslation} from "react-i18next";
import {path} from "src/router/path";
import {ArtistBackground, Button, LanguageSelector} from "src/components";
import "../styles/Error.scss";

const Error = () => {
  const navigate = useNavigate();
  const {t} = useTranslation("common");

  const location = useLocation();
  const artist = getArtistFromPath(location.pathname);

  const handleNavigateButton = () => {
    navigate(path.waiting(artist));
  };

  return (
    <div className="error-container">
      <ArtistBackground artist={artist} />
      <div className="error-header">
        <div />
        <LanguageSelector artist={artist} />
      </div>
      <div className="error-content">
        <div />
        <div className="error-summary">
          <img src={errorIcon} className="error-summary-icon" alt="" />
          <div className="error-notice">
            <div className="error-notice-title">{t("error.title")}</div>
            <div className="error-notice-description">
              {t("error.description")}
            </div>
          </div>
        </div>
        <Button
          artist={artist}
          label={t("error.button")}
          onClick={handleNavigateButton}
        />
      </div>
    </div>
  );
};

export default Error;
